import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import JSchemator from 'jschemator';
import isEqual from 'lodash/isEqual';
import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';

const Validated = (schema) => (WrappedComponent) => {
  const validator = JSchemator(schema, {}, 'es');

  class ValidatedComponent extends PureComponent {
    static propTypes = {
      values: PropTypes.object.isRequired,
      isSubmitted: PropTypes.bool.isRequired,
      handleValidation: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func.isRequired,
    };

    state = { isValid: false, errors: {} };

    validate = (next) => {
      const isValid = validator.validate(this.props.isSubmitted, this.props.values);

      const { $errors: errors } = validator;

      this.setState({ isValid, errors }, () => {
        this.props.handleValidation(isValid, !isValid && this.props.t('error.verify'));
        next && next();
      });
    };

    componentDidUpdate = (prevProps) => {
      if (!isEqual(prevProps.values, this.props.values)) {
        this.validate();
      }
    };

    handleSubmit = (e, ...args) => {
      e && e.preventDefault && e.preventDefault();
      this.validate(() => {
        this.props.handleSubmit({ isValid: this.state.isValid }, ...args);
      });
    };

    render = () => (
      <WrappedComponent
        {...this.props}
        isValid={this.state.isValid}
        errors={this.state.errors}
        handleSubmit={this.handleSubmit}
      />
    );
  }

  return translate()(ValidatedComponent);
};

export default Validated;



// WEBPACK FOOTER //
// src/components/util/Validated.js